import '@bessermitsenf/seedling'
import '../css/index.css'

import '../js/components/flipcard.js'
import '../js/components/recurring-events-slider.js'

// add class if firefox
if (navigator.userAgent.includes('Firefox')) {
  document.documentElement.classList.add('is-firefox')
}

